<template>
  <div class="powerStationWrap mainPageBg">
    <div class="powerStation">
      <div class="ashComWrap leftMenu">
        <div class="comTitle">
          <h4>电站概况</h4>
        </div>
        <div class="comContentBox">
          <el-descriptions
            :column="1"
            style="margin: 20px"
            contentClassName="descClassName"
          >
            <el-descriptions-item label="电站容量"
              >1000 kWp</el-descriptions-item
            >
            <el-descriptions-item label="年发电量"
              >2371538.2 kw·h</el-descriptions-item
            >
            <el-descriptions-item label="光伏组件数量"
              >224</el-descriptions-item
            >
            <el-descriptions-item label="光伏阵列面积"
              >7532.1 m²</el-descriptions-item
            >
            <el-descriptions-item label="逆变器数量">2</el-descriptions-item>
            <el-descriptions-item label="安装地点">江北区</el-descriptions-item>
            <el-descriptions-item label="投运日期"
              >2022-01-28</el-descriptions-item
            >
          </el-descriptions>
          <el-descriptions
            direction="vertical"
            :column="2"
            border
            style="margin: 0 20px"
          >
            <el-descriptions-item
              label="辐照"
              :contentStyle="{ 'text-align': 'center' }"
              :labelStyle="{ 'text-align': 'center' }"
              >200W/m²</el-descriptions-item
            >
            <el-descriptions-item
              label="光伏组件温度"
              :contentStyle="{ 'text-align': 'center' }"
              :labelStyle="{ 'text-align': 'center' }"
              >30℃</el-descriptions-item
            >
            <el-descriptions-item
              label="环境温度"
              :contentStyle="{ 'text-align': 'center' }"
              :labelStyle="{ 'text-align': 'center' }"
              >20℃</el-descriptions-item
            >
            <el-descriptions-item
              label="风速"
              :contentStyle="{ 'text-align': 'center' }"
              :labelStyle="{ 'text-align': 'center' }"
              >2.31m/s</el-descriptions-item
            >
          </el-descriptions>
        </div>
      </div>

      <div class="rightContent">
        <div class="topListWrap">
          <ul>
            <li
              v-for="(v, i) in colorList"
              :key="i"
              :style="{
                background: v.bg,
                borderColor: v.borderColor,
              }"
            >
              <h3>{{ v.data }} <span>kw·h</span></h3>
              <p>{{ v.name }}</p>
            </li>
          </ul>
        </div>
        <div class="dataListWrap">
          <div class="generating ashComWrap">
            <div class="comTitle">
              <h4>发电量</h4>
              <el-radio-group v-model="activeTime" size="mini">
                <el-radio-button label="日"></el-radio-button>
                <el-radio-button label="月"></el-radio-button>
                <el-radio-button label="年"></el-radio-button>
              </el-radio-group>
            </div>

            <div class="comContentBox">
              <GeneratingCharts />
            </div>
          </div>
          <div class="analysis ashComWrap">
            <div class="comTitle">
              <h4>电量消耗对比分析</h4>
              <el-radio-group v-model="activeTime1" size="mini">
                <el-radio-button label="日"></el-radio-button>
                <el-radio-button label="月"></el-radio-button>
                <el-radio-button label="年"></el-radio-button>
              </el-radio-group>
            </div>
            <div class="comContentBox">
              <AnalysisCharts />
            </div>
          </div>
        </div>
        <div class="equipmentWrap ashComWrap">
          <div class="comTitle">
            <h4>逆变器</h4>
          </div>
          <div class="comContentBox">
            <InverterCom />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GeneratingCharts from "@/components/zixitong/photovoltaicSystem/GeneratingCharts.vue";
import AnalysisCharts from "@/components/zixitong/photovoltaicSystem/AnalysisCharts.vue";
import InverterCharts from "@/components/zixitong/photovoltaicSystem/InverterCharts.vue";
import InverterCom from "@/components/zixitong/photovoltaicSystem/InverterCom.vue";
export default {
  components: {
    GeneratingCharts,
    AnalysisCharts,
    InverterCharts,
    InverterCom,
  },
  data() {
    return {
      activeTime: "年",
      activeTime1: "年",
      colorList: [
        {
          bg: "rgb(89,183,233)",
          borderColor: "rgb(14,150,222)",
          name: "今日发电量",
          data: 1092,
        },
        {
          bg: "rgb(173,150,224)",
          borderColor: "rgb(150,118,217)",
          name: "本周发电量",
          data: 5259,
        },
        {
          bg: "rgb(241,184,117)",
          borderColor: "rgb(234,137,21)",
          name: "本月发电量",
          data: 32578,
        },
        {
          bg: "rgb(99,197,207)",
          borderColor: "rgb(8,175,192)",
          name: "本年发电量",
          data: 5793463,
        },
      ],
      leftData: [
        { name: "型号", value: "XXXXXXXX", unit: "" },
        { name: "S/N号", value: "23523656572342", unit: "" },
        { name: "验证码", value: "8453", unit: "" },
        { name: "容量", value: "5", unit: "千瓦" },
        { name: "接入时间", value: "2022年2月1日", unit: "" },
        { name: "发电功率", value: "4", unit: "千瓦" },
        { name: "交流电压", value: "220", unit: "伏" },
        { name: "交流电压", value: "25.2", unit: "安" },
        { name: "交流频率", value: "50", unit: "赫兹" },
      ],
      rightData: [
        { name: "温度", value: "32", unit: "度" },
        { name: "直流电压/电流1", value: "432/111", unit: "伏/安" },
        { name: "直流电压/电流2", value: "432/111", unit: "伏/安" },
        { name: "直流电压/电流3", value: "432/111", unit: "伏/安" },
        { name: "直流电压/电流4", value: "-", unit: "伏/安" },
        { name: "组串电流1", value: "11.1/22.2/33.3", unit: "安" },
        { name: "组串电流2", value: "11.1/22.2/33.3", unit: "安" },
        { name: "组串电流3", value: "-", unit: "安" },
        { name: "组串电流4", value: "-", unit: "安" },
      ],
    };
  },
  methods: {},
  created() {},
};
</script>

<style lang="scss" scoped>
.powerStationWrap {
  @include setFlexCenter;
  .powerStation {
    width: 98%;
    height: 97%;
    @include setFlexBetween;
    .leftMenu {
      width: 25%;
      ::v-deep .el-descriptions__body {
        .descClassName {
          color: #8cc44d;
          font-size: 16px;
          font-weight: bold;
        }
      }
    }
    .rightContent {
      width: 74%;
      height: 100%;
      @include setFlexColumn;
      justify-content: space-between;
      .topListWrap {
        height: 13%;
        width: 100%;
        ul {
          width: 100%;
          height: 100%;
          @include setFlexBetween;
          li {
            width: calc(24% - 30px);
            height: 100%;
            border-left: 30px solid;
            color: #fff;
            @include setFlexColumn;
            justify-content: center;
            align-items: center;
            h3 {
              font-size: 28px;
              margin-bottom: 10px;
              span {
                font-size: 14px;
              }
            }
          }
        }
      }
      .dataListWrap {
        height: 42%;
        width: 100%;
        @include setFlexBetween;
        .generating,
        .analysis {
          width: 49%;
        }
      }
      .equipmentWrap {
        height: 42%;
        width: 100%;
      }
    }
  }
}
</style>
